import styled, { css } from 'styled-components';
import { fsDarkBlue, fsCyan, monokaiBackground, darkModeBackground, colors } from 'global/colors';

export const CanvasControllerBar = styled.div`
  position: relative;
  /* border-top: 1px solid ${colors.gray3}; */
  width: 100%;
  height: 35px;
  display: flex;
  flex-direction: row;
  ${({ isDarkMode }) => css`
    background: ${isDarkMode ? darkModeBackground : colors.white};
  `}
  justify-content: space-between;
`;

export const CanvasControllerContainer = styled.div`
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 35px;
  display: flex;
  flex-direction: row;
  column-gap: 5px;
`;

export const IconButtonContainer = styled.button`
  border: 0;
  line-height: 0;
  height: 25px;
  width: 25px;
  ${({ isDarkMode }) =>
    isDarkMode
      ? css`
          background-color: ${monokaiBackground};
          color: ${fsCyan};
        `
      : css`
          color: ${monokaiBackground};
        `}
  &:hover {
    ${({ isDarkMode }) =>
      isDarkMode &&
      css`
        background-color: ${monokaiBackground};
      `}
  }
  &:disabled {
    color: darkgray;
  }
`;

export const Icon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  font-size: 1rem;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${fsCyan};
    `}
`;

export const ProgressBarContainer = styled.div`
  cursor: pointer;
  background-color: ${colors.gray3};
  height: 2px;
  width: 100%;
  bottom: 35px;
  display: initial;
  position: absolute;
  &:hover {
    height: 10px;
    bottom: 33px;
  }
`;

export const ProgressBarFill = styled.div`
  left: 0px;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const ProgressBarLeft = styled.div.attrs(({ progressPercentage }) => ({
  style: { width: progressPercentage + '%' },
}))`
  ${({ isDarkMode }) => css`
    background: ${isDarkMode ? colors.gray : fsCyan};
  `}
`;

export const ProgressBarMarker = styled.div.attrs(({ progressPercentage, isHovering }) => {
  let offset = isHovering ? 10 : 4;
  return {
    style: {
      left: progressPercentage + '%',
      marginLeft: -offset + 'px',
    },
  };
})`
  position: absolute;
  overflow: hidden;
  top: -1px;
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  ${({ isDarkMode, isHovering }) => {
    let markerColor = isDarkMode ? fsCyan : fsDarkBlue;
    return css`
      border-bottom: 4px solid ${markerColor};
      ${() =>
        isHovering &&
        css`
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: 18px solid ${markerColor};
        `}
    `;
  }}
`;
